/** Nested blocks Vue 2 must not walk. The task object itself stays extensible. */
export const TASK_READ_ONLY_NESTS = [
  '__computed',
  '__tbtotals',
  'bot_details',
  'bot_recon_summary',
];

/**
 * Freeze read-only nests on each task. Shallow freeze is enough: Vue 2 skips
 * a frozen object and does not observe its children. The task stays writable
 * so status, assignment, and selection updates still land on the row.
 */
export function freezeTaskReadOnlyNests(task) {
  if (!task || typeof task !== 'object') return task;
  TASK_READ_ONLY_NESTS.forEach((key) => {
    const value = task[key];
    if (value && typeof value === 'object' && !Object.isFrozen(value)) {
      Object.freeze(value);
    }
  });
  return task;
}

export function freezeTaskListReadOnlyNests(tasks) {
  if (!Array.isArray(tasks)) return [];
  tasks.forEach(freezeTaskReadOnlyNests);
  return tasks;
}

/**
 * Checklist stored for one load. Returns that fetch's tasks only.
 * Callers assign the result; they do not concatenate onto the previous cycle.
 * SET_TASKLIST_DATA then does `state.taskListData = data`.
 */
export function taskChecklistForCommit(nextChecklist) {
  return Array.isArray(nextChecklist) ? nextChecklist : [];
}
